import { StringId } from '../localizer/stringId'

export const strings = {
  [StringId.DV_RBB_CANCEL_PURCH_MODAL_HEADER]: 'Cancel Your Digital Order',
  [StringId.DV_RBB_CANCEL_PURCH_MODAL_SUBMIT]: 'Cancel Order',
  [StringId.DV_AB_CANCEL_ACCIDENTAL_PURCHASE]:
    'Purchased by accident? {link|cancelLink}Cancel your order{end}'
}
